const _version = "2.5.5"
function version() {
    return _version;
}
export default version
